export const ICON_LEFT_ARROW = "itaufonts_seta";
export const ICON_RIGHT_ARROW = "itaufonts_seta_right";
//# sourceMappingURL=constants.js.map